import { isFunction } from 'lodash';

const dynamicParameter = parameter => isFunction(parameter) ? self => parameter(self) : () => parameter;

export { dynamicParameter };